import React, { useState, useEffect, useWindowFocus } from "react";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  getDoc,
  updateDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getCountFromServer,
  arrayUnion,
} from "@firebase/firestore";

import { auth, firebase } from "../Firebase/config";

import Classes from "./Mapofgclassroomclasses/Mapofgclassroomclasses";

// eslint-disable-next-line
import NavBar from "./Navbar";

import "./App.css";

function App() {
  // Extract URL parameters first - MUST be at the top
  const { only2studentid, studentid, classid, language, role, id } =
    useParams();

  const [temparray, setTemparray] = useState();

  const [selectedclass, setSelectedclass] = useState();
  const [activeid, setActiveid] = useState();
  const [activename, setActivename] = useState();

  const [selectedclass2, setSelectedclass2] = useState();
  const [activeid2, setActiveid2] = useState();
  const [activename2, setActivename2] = useState();

  const [currentclass, setCurrentclass] = useState();

  const [currentclasses, setCurrentclasses] = useState();
  const [currentstudents, setCurrentstudents] = useState();

  // state to store backend authoorizatiion

  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [town, setTown] = useState("");
  const [state, setState] = useState("");
  const [school, setSchool] = useState("");
  const [email, setEmail] = useState("");

  // Add a state to track when user data is loaded
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  // Add a state to trigger reload if loading takes too long
  const [reloadKey, setReloadKey] = useState(0);

  // Minimal mount check
  useEffect(() => {
    console.log("✅ Getyourgcclasses.js mounted.");
  }, []);

  // FIRST: Fetch user data - this runs before everything else
// Replace the fetchUserData useEffect with this version that includes retry logic:

useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlId = urlParams.get("id");
    const dataStoredInDatabase = urlParams.get("dataStoredInDatabase");

    console.log("🔍 URL Params:", {
        urlId,
        dataStoredInDatabase,
    });

    if (!urlId || dataStoredInDatabase !== "true") {
        console.warn("⚠️ id or dataStoredInDatabase not present in URL, skipping Firestore fetch");
        setUserDataLoaded(true);
        return;
    }

    const fetchUserData = async (retryCount = 0) => {
        const MAX_RETRIES = 3;
        const RETRY_DELAY = 1500; // 1.5 seconds

        try {
            console.log(`Fetching user data from Firestore for id: ${urlId} (attempt ${retryCount + 1})`);
            const docRef = doc(firebase, "users", urlId);
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
                const userData = docSnap.data();

                // Log all keys for debugging
                console.log("📋 All keys in user document:", Object.keys(userData));

                if (userData.empty) {
                    console.warn("⚠️ No user found with ID:", urlId);
                    setUserDataLoaded(true);
                    return;
                }

                setAccesstoken(userData.access_token || "");
                setRefreshtoken(userData.refresh_token || "");
                setExpiryDate(userData.expiry_date || "");
                setEmail(userData.email || "");

                if (userData.activeclassid) {
                    setActiveid(userData.activeclassid);
                    console.log("✅ Active class ID set:", userData.activeclassid);
                }

                if (userData.activeclassname) {
                    setActivename(userData.activeclassname);
                    console.log("✅ Active class name set:", userData.activeclassname);
                }

                if (userData.town) setTown(userData.town);
                if (userData.state) setState(userData.state);
                if (userData.school) setSchool(userData.school);

                // Check for fetchCourses data
                if (userData.fetchCourses && userData.fetchCourses.courses && Array.isArray(userData.fetchCourses.courses)) {
                    setTemparray(userData.fetchCourses.courses);
                    console.log("✅ Courses array set from Firestore:", userData.fetchCourses.courses.length);
                } else if (userData.fetchCourses && Array.isArray(userData.fetchCourses)) {
                    setTemparray(userData.fetchCourses);
                    console.log("✅ Courses array set from Firestore (direct array):", userData.fetchCourses.length);
                } else if (retryCount < MAX_RETRIES) {
                    // fetchCourses not found - retry after delay
                    console.warn(`⚠️ fetchCourses not found, retrying in ${RETRY_DELAY}ms... (attempt ${retryCount + 1}/${MAX_RETRIES})`);
                    setTimeout(() => {
                        fetchUserData(retryCount + 1);
                    }, RETRY_DELAY);
                    return; // Don't set userDataLoaded yet
                } else {
                    console.warn("⚠️ No fetchCourses data found after all retries");
                    setTemparray([]);
                }

                console.log("✅ User data fetch completed successfully");

            } else {
                console.warn("⚠️ No document found in Firestore for user id:", urlId);
                setTemparray([]);
            }

        } catch (error) {
            console.error("❌ Error fetching user data:", error);
            console.error("❌ Error stack:", error.stack);

            setActiveid("");
            setActivename("");
            setTown("");
            setState("");
            setSchool("");
            setTemparray([]);
        }
        
        setUserDataLoaded(true);
        console.log("🎉 User data loading complete - ready for next steps");
    };

    console.log("🔄 About to call fetchUserData...");
    fetchUserData();

}, []);
  useEffect(() => {
    console.log("🔍 URL parameters extracted - role:", role, "id:", id);
  }, [role, id]);

  useEffect(() => {
    if (typeof selectedclass2 != "undefined") {
      setActiveid2(selectedclass2.id);
      setActivename2(selectedclass2.name);
      console.log("selectedclass2 changed:", selectedclass2);
    }
  }, [selectedclass2]);

  //claassesss from the database


  // Show loading indicator until userDataLoaded is true
  if (!userDataLoaded) {
    return (
      <div className="App22">
        <NavBar
          role={role}
          temparray={currentclasses}
          activename2={activename2}
          selectedclass={selectedclass}
          setSelectedclass={setSelectedclass}
          activename={activename}
        />
        <div className="App">
          <header className="App-header"> <h2>Loading user data...</h2></header>
        </div>
      </div>
    );
  }

  return (
    <div className="App22">
      <NavBar
        role={role}
        temparray={currentclasses}
        activename2={activename2}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="App">
        <header className="App-header">
          <Classes
            currentclass={currentclass}
            activename={activename2}
            databaseactivename={activename}
            setSelectedclass={setSelectedclass2}
            activeid2={activeid2}
            activename2={activename2}
            selectedclass={selectedclass2}
            temparray={temparray}
            id={id}
            activeid={activeid}
            role={role}
            accesstokenn={accesstoken}
            refreshtokenn={refreshtoken}
            expirydatee={expiryDate}
            email={email}
          />
        </header>
      </div>
    </div>
  );
}

export default App;